import { render, staticRenderFns } from "./PreviewMentionsDialog.vue?vue&type=template&id=c09c7d94&scoped=true"
import script from "./PreviewMentionsDialog.vue?vue&type=script&lang=js"
export * from "./PreviewMentionsDialog.vue?vue&type=script&lang=js"
import style0 from "./PreviewMentionsDialog.vue?vue&type=style&index=0&id=c09c7d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09c7d94",
  null
  
)

export default component.exports